// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__TnD0C","slide-down":"Modal_slide-down__k-AsS","content":"Modal_content__etTzO"};